// in-app yes/no dialog (native confirm() can hang behind the full-screen map on some devices)
export function askConfirm(msg, { ok = 'OK', cancel = '✕' } = {}) {
  return new Promise((res) => {
    const host = document.fullscreenElement || document.body, wrap = document.createElement('div');
    wrap.className = 'ask-backdrop'; wrap.setAttribute('data-testid', 'confirm-dialog');
    wrap.innerHTML = '<div class="ask-box" role="alertdialog"><p></p><div class="ask-row"><button type="button" class="btn btn-outline" data-testid="confirm-cancel-btn"></button><button type="button" class="btn btn-red" data-testid="confirm-ok-btn"></button></div></div>';
    wrap.querySelector('p').textContent = msg;
    const [no, yes] = wrap.querySelectorAll('button');
    no.textContent = cancel; yes.textContent = ok;
    const done = (v) => { document.removeEventListener('keydown', key, true); wrap.remove(); res(v); };
    const key = (e) => { if (e.key === 'Escape') { e.stopPropagation(); done(false); } if (e.key === 'Enter') { e.preventDefault(); done(document.activeElement !== no); } };
    no.onclick = () => done(false); yes.onclick = () => done(true);
    wrap.onclick = (e) => e.target === wrap && done(false);
    document.addEventListener('keydown', key, true);
    host.appendChild(wrap); yes.focus();
  });
}
